// Verified developer credentials — publications, lectures, teaching, awards.
// Item titles/citations are kept verbatim (proper nouns/publication names).
// Only section headers are localised.

export const DEVELOPER_HEADINGS = {
  en: {
    lectures: "Lectures",
    publications: "Publications",
    book: "Book",
    columnist: "Columnist and Researcher",
    columnist_desc: "Portal Magis Jurídico (Feb. 2025 – Present). Monthly column \"Beyond Borders: International Family Law and U.S. Immigration,\" addressing international family law, private international law, mediation, and cross-border implementation.",
    scientific_article: "Scientific Article",
    additional: "Additional Co-Authored Publications",
    teaching: "Teaching Experience",
    teaching_block: "Training Projects — Associação Brasileira de Advogados (ABA-Brazil)",
    awards: "Awards and Professional Recognition",
    book_ranking_note: "The Kindle edition reached No. 3 in an Amazon Brazil sales ranking in July 2026. An English-language edition of the same methodology is in development.",
  },
  pt: {
    lectures: "Palestras",
    publications: "Publicações",
    book: "Livro",
    columnist: "Colunista e Pesquisadora",
    columnist_desc: "Portal Magis Jurídico (fev. 2025 – presente). Coluna mensal \"Beyond Borders: International Family Law and U.S. Immigration\", abordando Direito Internacional de Família, Direito Internacional Privado, mediação e implementação transfronteiriça.",
    scientific_article: "Artigo Científico",
    additional: "Publicações Coautoradas Adicionais",
    teaching: "Experiência em Docência",
    teaching_block: "Projetos de Formação — Associação Brasileira de Advogados (ABA-Brazil)",
    awards: "Prêmios e Reconhecimento Profissional",
    book_ranking_note: "A edição Kindle alcançou o nº 3 em um ranking de vendas da Amazon Brasil em julho de 2026. Uma edição em inglês da mesma metodologia está em desenvolvimento.",
  },
  es: {
    lectures: "Conferencias",
    publications: "Publicaciones",
    book: "Libro",
    columnist: "Columnista e Investigadora",
    columnist_desc: "Portal Magis Jurídico (feb. 2025 – presente). Columna mensual \"Beyond Borders: International Family Law and U.S. Immigration\", que aborda Derecho Internacional de Familia, Derecho Internacional Privado, mediación e implementación transfronteriza.",
    scientific_article: "Artículo Científico",
    additional: "Publicaciones Coautorizadas Adicionales",
    teaching: "Experiencia Docente",
    teaching_block: "Proyectos de Formación — Associação Brasileira de Advogados (ABA-Brazil)",
    awards: "Premios y Reconocimiento Profesional",
    book_ranking_note: "La edición Kindle alcanzó el nº 3 en un ranking de ventas de Amazon Brasil en julio de 2026. Una edición en inglés de la misma metodología está en desarrollo.",
  },
};

export const DEVELOPER_LECTURES = [
  { title: "Recognition of Foreign Judgments in Family Law",
    venue: "International and Immigration Law Commission, ABA-Brazil", year: "2026",
    role: "Speaker" },
  { title: "Division of Assets Abroad: Challenges and Solutions",
    venue: "International and Immigration Law Commission, ABA-Brazil", year: "2025",
    role: "Speaker" },
  { title: "Brazil-U.S. Marriage: What to Do When Divorce Occurs?",
    venue: "International and Immigration Law Commission, ABA-Brazil", year: "2025",
    role: "Speaker" },
];

export const DEVELOPER_BOOK = {
  citation: "MIFT — Metodologia Integrada de Mediação em Famílias Transnacionais: Um Guia Operacional para Atuação Jurídica e Mediação em Disputas Familiares Transnacionais. Co-authored with Diego Rycbczak Lopes. 1st ed., 2026. ISBN 978-65-979415-0-6. Print and Kindle editions available through Amazon.",
};

export const DEVELOPER_COLUMNS = [
  { title: "Mediation and ADR in Cross-Border Disputes: Execution Engineering for Cross-Border Agreements", date: "Oct. 2025" },
  { title: "Prenuptial Agreements with International Elements: Formal and Material Validity, Choice-of-Law Clauses, Public Policy Limits, and Asset-Protection Techniques", date: "Sep. 2025" },
  { title: "Sharing Assets Abroad: Legal Challenges and Solutions for International Real Estate and Financial Assets", date: "July 2025" },
  { title: "International Divorce and the Law of Residence: Legal Challenges of Transnational Marital Dissolution", date: "Apr. 2025" },
];

export const DEVELOPER_SCIENTIFIC = {
  citation: "Compliance Tributário Internacional: Desafios e Estratégias na Gestão do IVA e o Uso de Paraísos Fiscais. RevistaFT, Applied Social Sciences, vol. 28, no. 139, Oct. 2024. DOI: 10.69849/revistaft/ni10202410220653.",
  doi_url: "https://doi.org/10.69849/revistaft/ni10202410220653",
};

export const DEVELOPER_ADDITIONAL = [
  "Magis de Direito: Debates Jurídicos Contemporâneos (3rd ed.) — Chapter on prenuptial agreements with international elements, choice-of-law clauses, public policy, and asset-protection techniques.",
  "Contemporary Topics in International and Immigration Law — Chapter on division of assets abroad and legal issues involving international real estate and financial assets.",
];

export const DEVELOPER_TEACHING = [
  {
    role: "Instructor",
    title: "Internationalization in Practice: International Legal Training Series",
    venue: "International and Immigration Law Commission",
    period: "Oct. 2025 – Present",
    desc: "Leads and supports the International Family and Succession Law module and prepares syllabi, readings, bilingual checklists, practical templates, and materials for the institutional repository.",
  },
];

export const DEVELOPER_AWARDS = [
  {
    year: "2026",
    title: "Legal Honor Global Awards — Nominee, Leading Lawyer of the Year",
    venue: "LexTalk World Conference & Exhibition, Houston, Texas",
  },
];
